import React, { Component } from "react";
import Prism from "prismjs";

export default class Code extends Component {
  componentDidMount() {
    setTimeout(() => Prism.highlightAll(), 0);
  }
  render() {
    return (
      <pre classNaame="line-numbers">
        <code className="language-clike">{this.props.children}</code>
      </pre>
    );
  }
}
